module.exports = __webpack_public_path__ + "static/media/30e47c06-7f57-41da-ae80-42d0b6c67f34.e0c32b1f.webp";